import { Component } from '@angular/core';

@Component({
    selector: 'extra-layout',
    templateUrl: 'extra.component.html',
    styleUrls: ['extra.component.scss'],
    standalone: false
})
export class ExtraLayoutComponent {
  rtl = false;

  constructor() { }
}
